// src/pages/Settings.js
import React, { useState, useEffect } from 'react';
import { Save, RefreshCw } from 'lucide-react';
import api from '../utils/api';
import { useToast } from '../contexts/ToastContext';

export default function Settings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [changes, setChanges] = useState({});
  const toast = useToast();

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get('/settings'); setSettings(data); } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const set = (category, key, value) => {
    setChanges(p => ({ ...p, [`${category}.${key}`]: value }));
    setSettings(p => ({ ...p, [category]: { ...p[category], [key]: { ...p[category]?.[key], value } } }));
  };

  const save = async () => {
    setSaving(true);
    try { await api.put('/settings', changes); toast.success('Setări salvate'); setChanges({}); }
    catch (e) { toast.error('Eroare la salvare'); } finally { setSaving(false); }
  };

  if (loading) return <div className="loading-center"><span className="spinner" /></div>;

  const renderField = (category, key, s) => {
    if (s.type === 'boolean') return <select className="form-select" value={s.value} onChange={e => set(category, key, e.target.value)}><option value="true">Da</option><option value="false">Nu</option></select>;
    if (s.type === 'number') return <input className="form-input" type="number" value={s.value || ''} onChange={e => set(category, key, e.target.value)} />;
    return <input className="form-input" value={s.value || ''} onChange={e => set(category, key, e.target.value)} />;
  };

  const CATEGORY_LABELS = { general: 'General', notifications: 'Notificări', security: 'Securitate' };

  return (
    <div className="fade-in">
      <div className="page-header">
        <div><div className="page-title">Setări</div><div className="page-subtitle">Configurare aplicație</div></div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-secondary" onClick={load}><RefreshCw size={15} /></button>
          <button className="btn btn-primary" onClick={save} disabled={saving || Object.keys(changes).length === 0}>
            {saving ? <span className="spinner" /> : <><Save size={15} /> Salvare</>}
          </button>
        </div>
      </div>

      {Object.entries(settings).map(([cat, catSettings]) => (
        <div key={cat} className="card" style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 20, paddingBottom: 12, borderBottom: '1px solid var(--border)' }}>
            {CATEGORY_LABELS[cat] || cat}
          </h3>
          <div className="form-grid form-grid-2">
            {Object.entries(catSettings).map(([key, s]) => (
              <div key={key} className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">{s.label || key}</label>
                {renderField(cat, key, s)}
                {s.description && <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginTop: 4 }}>{s.description}</div>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
